export default __webpack_public_path__ + "static/media/declarer_depart.f0948538.svg";